import './public-path';
import '../styles/app.scss';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/grid';
import './_images';
import FooterDetails from './components/FooterDetails';
import MasonryGrid from './components/MasonryGrid';
import FaqTabs from './components/faq-tabs';
import ProgramScheduleTabs from './components/program-schedule-tabs';
import FormAssemblyFix from './components/FormAssemblyFix';
import FormAssemblyScroll from './components/FormAssemblyScroll';
import PopupClose from './components/PopupClose';
import PardotLazyLoad from './components/PardotLazyLoad';
import TabLink from './components/TabLink';
import FacultyToursTabs from './components/faculty-tours-tabs';
import TopicSubtopics from './components/TopicSubtopics';
import FacultyLoadMore from './components/FacultyLoadMore';
import SearchToolPopup from './components/SearchToolPopup';
import SearchOverlay from './components/SearchOverlay';
import ArchiveHashScroll from './components/ArchiveHashScroll';
import SearchResultsForm from './components/SearchResultsForm';
import SponsorshipsArchive from './components/SponsorshipsArchive';
import PardesnikInspirationBioToggle from './components/PardesnikInspirationBioToggle';
import EndowOpportunities from './components/EndowOpportunities';
import BuildOpportunities from './components/BuildOpportunities';
import BuildPlansTimeline from './components/BuildPlansTimeline';
import MegaMenu from './components/MegaMenu';
import StudentSpendingTabs from './components/student-spending-tabs';
import VideoMessagesPlayButtons from './components/VideoMessagesPlayButtons';
import FellowsLeaders from './components/FellowsLeaders';
import EntranceAnimation from './components/EntranceAnimation';
import FeaturedImageOrientation from './components/FeaturedImageOrientation';
import CapitalCampaignCta from './components/CapitalCampaignCta';

EntranceAnimation.markReady();

const lazyInit = (selector, load) => {
	if (!document.querySelector(selector)) return;
	load()
		.then((module) => module.default.init())
		.catch((error) => console.error(`Failed to load component for ${selector}`, error));
};

document.addEventListener(
	'DOMContentLoaded',
	() => {
		FooterDetails.init();
		FaqTabs.init();
		ProgramScheduleTabs.init();
		FormAssemblyFix.init();
		FormAssemblyScroll.init();
		PopupClose.init();
		PardotLazyLoad.init();
		TabLink.init();
		FacultyToursTabs.init();
		TopicSubtopics.init();
		FacultyLoadMore.init();
		SearchToolPopup.init();
		SearchOverlay.init();
		ArchiveHashScroll.init();
		SearchResultsForm.init();
		SponsorshipsArchive.init();
		PardesnikInspirationBioToggle.init();
		StudentSpendingTabs.init();
		EndowOpportunities.init();
		BuildOpportunities.init();
		BuildPlansTimeline.init();
		MegaMenu.init();
		VideoMessagesPlayButtons.init();
		FellowsLeaders.init();
		FeaturedImageOrientation.init();
		CapitalCampaignCta.init();

		window.pardesEntranceAnimation = EntranceAnimation.init();

		lazyInit('.pin-desktop', () => import(/* webpackChunkName: "pinned-sections" */ './components/PinnedSections'));
		lazyInit(
			'[data-component="testimonials-slider"], .team-member__listing, [data-component="havruta-archive"], .single-post__carousel, .programs__carousel, .community-cards-slider, .wp-block-gallery.logo-gallery',
			() => import(/* webpackChunkName: "sliders" */ './lazy/sliders')
		);
		lazyInit(
			'[data-component="events"], [data-tz-convert], [data-tz-pill]',
			() => import(/* webpackChunkName: "events" */ './lazy/events')
		);
		lazyInit('[data-component="library-archive"]', () => import(/* webpackChunkName: "library-archive" */ './components/OnlineLibraryArchive'));
		lazyInit('[data-component="single-online-library"]', () => import(/* webpackChunkName: "single-online-library" */ './components/SingleOnlineLibrary'));
		lazyInit('[data-component="news-archive"]', () => import(/* webpackChunkName: "news-archive" */ './components/NewsArchive'));
		lazyInit('[data-component="all-topics"]', () => import(/* webpackChunkName: "all-topics" */ './components/AllTopics'));
		lazyInit('[data-component="topic-posts"]', () => import(/* webpackChunkName: "topic-posts" */ './components/TopicPosts'));
		lazyInit('[data-component="books-archive"]', () => import(/* webpackChunkName: "books-archive" */ './components/BooksArchive'));
		lazyInit('[data-component="programs-archive"]', () => import(/* webpackChunkName: "programs-archive" */ './components/ProgramsArchive'));
		lazyInit('[data-component="search-tool-results"]', () => import(/* webpackChunkName: "search-tool-results" */ './components/SearchToolResults'));

		new MasonryGrid('.masonry-grid .jet-listing-grid__items');
	},
	false
);
